import { useContext, useEffect } from 'react';
import { MusicianCard } from './MusicianCard';
import { GlobalContext } from '../context/GlobalState';

export const MusiciansTab = () => {
  const {
    musicians,
    isLoggedIn,
    userId,
    loadMusicians,
    isMusiciansLoading,
    musiciansLoaded,
  } = useContext(GlobalContext);

  useEffect(() => {
    loadMusicians();
  }, [loadMusicians]);

  const visibleMusicians = isLoggedIn
    ? musicians.filter(musician => musician.userId !== userId)
    : musicians;

  if (isMusiciansLoading && !musiciansLoaded) {
    return <div className='message'>Loading musicians...</div>;
  }

  if (musiciansLoaded && visibleMusicians.length === 0) {
    return <div className='message'>No musician listings found.</div>;
  }

  return (
    <ul className='cards cards-musicians'>
      {visibleMusicians.map(musician => (
        <MusicianCard key={musician._id} musician={musician} />
      ))}
    </ul>
  );
};
